import bookKeepingSetting from './book-keeping-settings.js';

export default [...bookKeepingSetting];
